module.exports = __webpack_public_path__ + "static/img/图层 17.ecb1fee9.png";